import PaymentStatusTag from "./PaymentStatusTag";

export default PaymentStatusTag;
